import * as R from 'ramda';
import { Action } from 'redux';
import { ActionType } from './core/redux/actionType';
import { AppState } from './core/redux/appState';


type ShowTimedOutAction = {
  type     : ActionType.ShowTimedOutAction;
  showModal: boolean;
}


export const showTimedOutAction = (
  show: boolean,
): ShowTimedOutAction => ({
  type:      ActionType.ShowTimedOutAction,
  showModal: show,
});


export const showTimedOutReducer = (state: AppState, action: Action): AppState => {
  if (action.type !== ActionType.ShowTimedOutAction) {
    return state;
  }

  return R.assoc('showTimedOut', (action as ShowTimedOutAction).showModal, state);
};
